import { SCHEMA_VERSION } from '@stageplottter/core';

/** True when the board was written by a newer client than this one (it must not write to it). */
export function isDocTooNew(schemaVersion: number, supported: number = SCHEMA_VERSION): boolean {
  return schemaVersion > supported;
}

/**
 * The collab URL with this client's schema version: the server keeps clients of an older schema
 * (tabs opened before a deploy) read-only (U99).
 */
export function withSchemaParam(url: string, version: number = SCHEMA_VERSION): string {
  return `${url}${url.includes('?') ? '&' : '?'}schema=${version}`;
}

/** Version-1 cache names carried no version; v5 is the first schema with a versioned cache. */
const FIRST_VERSIONED_CACHE = 5;

/**
 * IndexedDB name of a document's local cache. It carries the schema version, so a reload with a
 * new bundle does not replay edits an older client cached (and the server rejected, U99).
 */
export function localCacheName(docName: string, version: number = SCHEMA_VERSION): string {
  return `stageplottter:${docName}@v${version}`;
}

/** Cache names older clients used for the same document – deleted when the current one opens. */
export function staleCacheNames(docName: string, version: number = SCHEMA_VERSION): string[] {
  const names = [`stageplottter:${docName}`];
  for (let v = FIRST_VERSIONED_CACHE; v < version; v++) names.push(localCacheName(docName, v));
  return names;
}
